import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Layout: React.FC = () => {
  const location = useLocation();
  const hideHeaderFooter =
    location.pathname === "/" || location.pathname === "/login";

  return (
    <div className="fixed inset-0 flex flex-col bg-orange-50">
      {/* === Conditional Header === */}
      {!hideHeaderFooter && <Header />}

      {/* === Scrollable Main Content === */}
      <main
        className={`flex-1 overflow-y-auto ${
          hideHeaderFooter ? "" : "pt-[80px] pb-[70px]"
        }`}
      >
        <Outlet />
      </main>

      {/* === Conditional Footer === */}
      {!hideHeaderFooter && <Footer />}
    </div>
  );
};

export default Layout;
